<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo.length > 0" class="top-banner-area topo-cel">
    <div class="top-banner-content">

      <img
        class="top-banner-image"
        :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem"
        :alt="bannerTopo[0].itiNome"
      />

      <div class="top-banner-overlay">
        <div class="container">
          <div class="row align-items-center h-100">
            <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12">
              <div class="hero-caption hero-caption2">
                <h2>{{ bannerTopo[0].itiNome }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!--  final banner -->

  <!--=== informações ==========-->
  <section class="mt-80">
    <div class="services-area2 section-padding-info">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-8 order-lg-1">
            <div class="filter-widget">
              <ul class="filter-catagories">
                <li v-for="(menu, menuIndex) in informacoes" :key="menuIndex">
                  <a href="#" @click.prevent="carregaTexto(menu.itiId)">{{ menu.itiNome }}</a>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="informacao != ''" class="col-lg-9 order-lg-2 titulo-informacao pl-30" style=" margin-bottom: 100px;">
            <h3>{{ informacao[0].itiNome }}</h3><br>
            <p v-html="informacao[0].itiResumo1"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- final informações -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'InformacoesView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    informacoes: [],
    informacao: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
          { name: "keywords", content: "" }
        ],
      })
    },
    
    carregaTexto(value) {
      this.informacao = this.informacoes.filter(x => x.itiId == value)
      if (this.informacao.length > 0) {
        this.carregaMetas(
          this.removerTagsHTML(this.informacao[0].itiResumo1 || ''),
          this.informacao[0].itiNome || 'Informações'
        );
      }
    },
  },
  created() {

    axios.get('/Process/InsInstitucional/institucional/17/informacoesgeraistopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/institucional/18/informacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);

        if (this.id) {
          this.carregaTexto(this.id);
        } else if (this.informacoes.length > 0) {
          this.carregaTexto(this.informacoes[0].itiId);
        }

        // ✅ Chama carregaMetas baseado no conteúdo principal
        if (this.informacoes.length > 0) {
          this.carregaMetas(
            this.removerTagsHTML(this.informacoes[0].itiResumo1 || ''),
            this.informacoes[0].itiNome || 'Informações');
        }
        console.log('informações')
        console.log(this.informacoes)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped>
.top-banner-area {
  width: 100%;
  overflow: hidden;
}

.top-banner-content {
  position: relative;
  width: 100%;
  height: clamp(180px, 26vw, 420px);
  background: #000;
}

.top-banner-image {
  width: 100%;
  height: 100%;
  /*object-fit: contain; /* mostra a imagem inteira */
  object-position: center;
  display: block;
}

.top-banner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
}

.top-banner-overlay .container,
.top-banner-overlay .row {
  height: 100%;
}

.hero-caption2 {
  color: #fff;
}

.hero-caption2 h2 {
  margin: 0;
  color: #fff;
}

/* notebook 1366 */
@media (min-width: 1200px) and (max-width: 1366px) {
  .top-banner-content {
    height: 300px;
  }
}

/* tablet */
@media (max-width: 991px) {
  .top-banner-content {
    height: 240px;
  }
}

/* mobile */
@media (max-width: 767px) {
  .top-banner-content {
    height: 160px;
  }

  .top-banner-image {
    object-fit: cover;
  }

  .hero-caption2 h2 {
    font-size: 22px;
  }
}
</style>